import {
 SET_INITIAL_REQUIRED_DATA,
 SET_RESET_REGISTRATION_STATE,
 IS_REGISTRATION_SUCCESS,
 DISCOM_OPTIONS,
 STATE_OPTIONS,
 DISCOM_CON_OPTIONS,
 STATE_CON_OPTIONS,
} from "./types";

const initialState = {
 isRegistrationSucc: false,
 allCategoryTypes: undefined,
 energyTypes: undefined,
 specificationTypes: undefined,
 controlAreaTypes: undefined,
 subsidyTypes: undefined,
 discomTypes: undefined,
 gridConnectivityTypes: undefined,
 voltageLevelTypes: undefined,
 regionTypes: undefined,
 allStateTypes: undefined,
 allCityTypes: undefined,
 allCreditRatings: undefined,
 allPointDrawl: undefined,
 getNationality: undefined,
};

const registrationReducer = (state = initialState, action) => {
 if (action.type) {
  switch (action.type) {
   case SET_RESET_REGISTRATION_STATE:
    return {
     isRegistrationSucc: false,
     allCategoryTypes: undefined,
     energyTypes: undefined,
     specificationTypes: undefined,
     controlAreaTypes: undefined,
     subsidyTypes: undefined,
     discomTypes: undefined,
     gridConnectivityTypes: undefined,
     voltageLevelTypes: undefined,
     regionTypes: undefined,
     allStateTypes: undefined,
     allCityTypes: undefined,
     allCreditRatings: undefined,
     allPointDrawl: undefined,
     getNationality: undefined,
    };
   case SET_INITIAL_REQUIRED_DATA:
    return {
     ...state,
     ...action.payload,
    };
   case IS_REGISTRATION_SUCCESS:
    return {
     ...state,
     isRegistrationSucc: action.payload,
    };
   case STATE_OPTIONS:
    return {
     ...state,
     stateOptions: action.payload,
    };
   case DISCOM_OPTIONS:
    return {
     ...state,
     discomOptions: action.payload,
    };
   case STATE_CON_OPTIONS:
    return {
     ...state,
     stateOptionsCon: action.payload,
    };
   case DISCOM_CON_OPTIONS:
    return {
     ...state,
     discomOptionsCon: action.payload,
    };
   default: {
    return state;
   }
  }
 }
};

export default registrationReducer;
